import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ServiceLayer } from '../../../services/serviceLayer';
import * as _ from 'lodash';
import { DAO, reportClaimModel } from '../../../modal/DAO';
import { ConfirmationService } from 'primeng/api';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/app/services/commonService';
import { Settings } from 'src/app/services/settings';
declare var jQuery: any;
declare var require: any
let jsonPathRef = require('jsonpath');

@Component({
  selector: 'report-claim',
  templateUrl: './report-claim.component.html',
  styleUrls: ['./report-claim.component.css']
})
export class ReportClaimComponent implements OnInit {
  @Input() PolicyQuotesList: any = [];
  public filteredList = [];
  public PolicyorName: any = "";
  public ClientID: any = "";
  public policyDetails: any = {};
  public typeOfLossList = [];
  public subTypeOfLossList = [];  
  public FileUploadList = [];  
  public uploadFiles = [];
  @Output() popupClose = new EventEmitter<any>();
  public isShowError: boolean = false;
  public isShowSubType: boolean = false;
  public showReportClaimConfirmation: boolean = false;
  public minLossDate: Date = new Date();
  public maxLossDate: Date = new Date();
  public minYear: any = "";
  public maxYear: any = "";
  public ClaimNumber: string = "";
  public ErrorMessage: string = "";
  public IsBFMInternal: boolean = false;
  public IsLoading : boolean = false;
  @Input() isFromManagePolicy: boolean = false;
  @Input() isShowReportClaim: boolean = false;
  @Input() currentPolicyDetail: any;
  @Input() currentPolicy: any;
  @Input() tempPolicyList: any;
  @ViewChild('reportForm') reportForm: any;

  constructor(public serviceLayer: ServiceLayer, private sanitizer: DomSanitizer, public dao: DAO, public confirmationService: ConfirmationService, private commonService: CommonService,private setting: Settings) { }

  async ngOnInit() {
    this.IsLoading = true; 
    try {
    jQuery('.p-fileupload-content').on('click', function (event) {
      this.fileUpload();
    });
    var loginDetails = JSON.parse(window.localStorage.getItem("loginUserDetails"));
    if(loginDetails?.isinternal && (loginDetails?.email).includes("@berkleymarine.com")){
      this.IsBFMInternal = loginDetails?.isinternal;
    }
    await this.getDropdownData();
    if (!this.isFromManagePolicy) {
      this.PolicyQuotesList = await this.serviceLayer.getSearchPoliciesList('Policy');
      this.tempPolicyList = this.PolicyQuotesList;
      await this.serviceLayer.getUnderWriterInformation();
      var currentPolicyDetails = window.localStorage.getItem("currentPolicy");
      var currentPolicyType = window.localStorage.getItem("policyType");
      if (currentPolicyType == 'Report a claim' && currentPolicyDetails != undefined && currentPolicyDetails != null && currentPolicyDetails != "" && currentPolicyDetails != "null") {
        currentPolicyDetails = JSON.parse(currentPolicyDetails);
        window.localStorage.setItem("currentPolicy", null);
        this.PolicyorName = currentPolicyDetails['policyNumber'];
        this.filterPolicy();
      }
      this.postUserActivity(this.PolicyQuotesList,'Success',0,"Load Report a Claim","policies","searchPoliciesGrid",[this.dao.loginUserDetail.email, this.dao.loginUserDetail?.isInternal == false ? this.dao.loginUserDetail?.isInternal : true, (this.dao.loginUserDetail?.agencies == undefined || this.dao.loginUserDetail?.agencies == '') ? null : this.dao.loginUserDetail?.agencies]);
    }
    else {
      this.openPopup(this.currentPolicyDetail);
      this.postUserActivity(this.currentPolicyDetail,'Success',0,"Open Policy Details","policies","searchPoliciesGrid",[this.dao.loginUserDetail.email, this.dao.loginUserDetail?.isInternal == false ? this.dao.loginUserDetail?.isInternal : true, (this.dao.loginUserDetail?.agencies == undefined || this.dao.loginUserDetail?.agencies == '') ? null : this.dao.loginUserDetail?.agencies]);
    }
  }catch (error) {
    console.error("Error during init:", error);
  } finally {
    this.IsLoading = false; // hide spinner once all done
  }
}
  async getDropdownData() {
    this.typeOfLossList = [];
    let payload = { "urlData": [] }
    let response: any = await this.commonService.get("reportClaim", "getDropdowns", payload).toPromise();
    if (response) {
      this.typeOfLossList = response?.typeOfLoss;
      this.subTypeOfLossList = response?.subTypeOfLoss;   
    }
  }
  CreateOnlineQuote() {
    let quoteURL = this.setting.quickQuotePolicyUrl + 'Questions/BFM/BR/';
    window.open(quoteURL);
  }
  filterPolicy() {
    this.filteredList = [];
    if (this.PolicyorName != "" && this.PolicyorName.length > 2 && this.tempPolicyList != undefined && this.tempPolicyList != null && this.tempPolicyList.length > 0) {
      this.PolicyQuotesList = this.tempPolicyList.filter(policy => policy.typeName == 'Policy' && (((policy.policyNumber != null) && (policy.policyNumber).toLowerCase().includes(this.PolicyorName)) || ((policy.nameInsured != null) && policy.nameInsured.toLowerCase().includes(this.PolicyorName.toLowerCase()))));
      if (this.PolicyQuotesList.length > 0) {
        this.filteredList = this.PolicyQuotesList.slice(0, 10);
      }
    }
    else {
      this.filteredList = [];
    }
  }
  async openReportClaim(policy, i) {
    var element = document.getElementById("GettingID");
    if (element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.policyDetails = await this.serviceLayer.getPolicyDetails(policy.policyNumber,policy.policyMod);
    this.policyDetails.status = policy.status;
    this.policyDetails.modifyDate = policy.modifyDate;
    if (element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.currentPolicy = policy;
    this.dao.agencyCode = this.policyDetails?.agencyInfo?.code;
    this.dao.policyNumber = this.currentPolicy?.policyNumber;
    this.dao.insuredName = this.currentPolicy?.nameInsured;
    this.postUserActivity(this.policyDetails,'Success',0,"Open Policy Details","ManagePolicy", "PolicyDetails",[this.dao.loginUserDetail.userCompany,this.dao.policyNumber,50]);
    this.resetValues();
  }
  openPopup(policyDetails) {
    this.policyDetails = _.cloneDeep(policyDetails);
    this.resetValues();
  }
  resetValues() {
    this.isShowError = false;
    this.isShowReportClaim = true;
    this.minLossDate = new Date(this.policyDetails?.policyStartDate);
    this.maxLossDate = ['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION'].includes(this.policyDetails?.status.toUpperCase()) ? new Date(this.policyDetails.modifyDate) : 
      new Date() < new Date(this.policyDetails?.policyEndDate) ? new Date() : new Date(this.policyDetails?.policyEndDate);
    this.minYear = this.minLossDate.getFullYear();
    this.uploadFiles = [];
    this.maxYear = this.maxLossDate.getFullYear();
    this.ClaimNumber = "";
    this.ErrorMessage = "";
    this.isShowSubType = false;
    this.ClientID = this.policyDetails?.clientInfo?.clientID;
    this.dao.reportClaimData = new reportClaimModel();
  }
  paginate(event) {
    this.filteredList = this.PolicyQuotesList.slice((event.page) * 10, (event.page) * 10 + 10);
  }
  async submitReportClaim() {
    if (this.dao.reportClaimData.isLossProjectAddress != undefined && this.dao.reportClaimData.isLossProjectAddress != '') {
      // this.confirmationService.confirm({
      //   message: 'Do you want to submit the report claim ?',
      //   header: 'Report a Claim',
      //   accept: async () => {
          await this.reportClaimSubmit();
      //   }
      // });
    }
    // else{
    //   this.isShowError = true;
    // }
  }
  async reportClaimSubmit() {
    var element = document.getElementById("GettingReportClaimID");
    if (element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.dao.reportClaimData.PolicyNumber = this.policyDetails.policyNumber;
    this.dao.reportClaimData.EffectiveDate = new Date(this.policyDetails?.policyStartDate);
    this.dao.reportClaimData.ExpirationDate = new Date(this.policyDetails?.policyEndDate);
    this.dao.reportClaimData.Email = this.dao.reportClaimData.Email; 
    this.dao.reportClaimData.LoginFirstName = this.dao.loginUserDetail.given_name;
    this.dao.reportClaimData.LoginLastName = this.dao.loginUserDetail.family_name;
    // this.dao.reportClaimData.TypeOfLoss = this.dao.reportClaimData.SubTypeOfLoss != '' ? this.dao.reportClaimData.SubTypeOfLoss : this.dao.reportClaimData.TempTypeOfLoss;
    this.dao.reportClaimData.TypeOfLoss = "PR";
    this.dao.reportClaimData.CauseOfLoss = this.dao.reportClaimData.SubTypeOfLoss != '' ? this.dao.reportClaimData.SubTypeOfLoss : this.dao.reportClaimData.TempTypeOfLoss;
    this.dao.reportClaimData.PolicyType = "InlandMarine";
    this.dao.reportClaimData.FileDocumentID = [];
    if(this.dao.reportClaimData.isLossProjectAddress == "Yes"){
      this.dao.reportClaimData.Address = this.policyDetails?.clientInfo?.jobsiteAddress[0]?.addressNo + ' ' + this.policyDetails?.clientInfo?.jobsiteAddress[0]?.addressLine1;
      this.dao.reportClaimData.City = this.policyDetails?.clientInfo?.jobsiteAddress[0]?.city;
      this.dao.reportClaimData.State = this.policyDetails?.clientInfo?.jobsiteAddress[0]?.state;
      this.dao.reportClaimData.Zip = this.policyDetails?.clientInfo?.jobsiteAddress[0]?.zip;
    }
    this.dao.reportClaimData.InsuredName = this.dao.insuredName;
    this.dao.reportClaimData.ReferenceNumber = this.policyDetails.referenceNumber;
    this.uploadFiles?.map(c=>{
      this.dao.reportClaimData.FileDocumentID.push(c?.docID);
    })
    let formData1 = new FormData();
    if(this.uploadFiles?.length != 0){        
      this.uploadFiles.map(async(c)=>{          
        formData1.append('Files', c, c?.name);
      });
    } 
    const blobOverrides = new Blob([JSON.stringify(this.dao.reportClaimData)], {
      type: 'application/json',
    });
    formData1.append('reportClaimDTO',blobOverrides);
    var accessToken = this.dao?.loginUserDetail?.accessToken;
    // accessToken = "trdx";
    formData1.append('accessToken',accessToken);
    let response = await this.serviceLayer.ReportClaim(formData1);
    let xmlData = jsonPathRef.query(response, "$.claimNumber");
    await this.reportClaimChangesAfterSubmit(xmlData);
    // await this.serviceLayer.RequestEvidence(EvidenceData, currentPolicy?.companyCode, currentPolicy?.productCode, currentPolicy?.referenceNumber);
    if (element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
  }
  async reportClaimChangesAfterSubmit(xmlData){
    if (xmlData && xmlData.length > 0 && xmlData[0] != null) {
      this.ClaimNumber = xmlData[0];
      let mailData:any={};
      mailData.claimNumber = this.ClaimNumber;
      mailData.userEmail = this.dao.loginUserDetail.email;
      mailData.policyNumber = this.policyDetails.policyNumber;
      mailData.referenceNumber = this.policyDetails.referenceNumber;      
      let formData = new FormData();
      // await this.serviceLayer.SendMailConfirm(mailData);
      if(this.uploadFiles?.length != 0){        
        this.uploadFiles.map(async(c)=>{          
          formData.append('Files', c, c?.name);
        });
      }       
      mailData.Files = formData;
      await this.serviceLayer.SendMailConfirm(mailData);        
      this.showReportClaimConfirmation = true;      
    }
    else {
      this.ClaimNumber = "";
      // this.ErrorMessage = jsonPathRef.query(JSON.parse(response), "$..faultstring")[0];
      this.showReportClaimConfirmation = true;
    }  
  }
  closeReportClaim() {
    this.isShowReportClaim = false;
    this.showReportClaimConfirmation = false;
    this.isShowError = false;
    this.ClaimNumber = "";    
    this.ErrorMessage = "";
    if (this.reportForm) {
      this.reportForm.submitted = false;
    }
    if (this.isFromManagePolicy) {
      this.popupClose.emit();
    }
  }
  async onUpload(event) {
    let response = await this.onSelectFile(event.files);
  }
  public onSelectFile(files) {
    if (files.length === 0) {
      return '';
    }
    let uploadArray = this.uploadFiles;
    var totalFilesize = files[0].size;
    var FileExt: string = files[0].name.split('.').pop().toLowerCase();
    if (FileExt == 'csv' || FileExt == 'xlsx' || FileExt == 'xls' || FileExt == 'docx' || FileExt == 'doc' || FileExt == 'pdf' || FileExt == 'jpg') {
      if (uploadArray && uploadArray.length > 0) {
        uploadArray.forEach(u => {
          totalFilesize = totalFilesize + u.size;
        });
      }
      if (totalFilesize <= 15728640) {
        let fileToUpload = files[0];
        fileToUpload.progressValue = 0;
        let formData = new FormData();
        formData.append('Files', fileToUpload, fileToUpload.name);
        let payload = { "payloadData": formData, "urlData": [this.ClientID, "lossRunDocument"] }

        let interval = setInterval(() => {
          if (fileToUpload.progressValue <= 85) {
            fileToUpload.progressValue = fileToUpload.progressValue + Math.floor(Math.random() * 10) + 1;
            if (fileToUpload.progressValue >= 85) {
              clearInterval(interval);
              fileToUpload.progressValue = 100;
            }
          }
          else {
            clearInterval(interval);
            fileToUpload.progressValue = 100;
          }
        }, 120);
        // this.commonService.post('upload', 'FileUpload', payload).subscribe((event: any) => {
        //   if (event) {
            uploadArray.push(fileToUpload);
            fileToUpload.filesize = this.bytesToSize(fileToUpload.size);
            fileToUpload.fileName = fileToUpload.name;
            // fileToUpload.docID = JSON.parse(event)?.value;
        //   }
        // });
        return '';
      }
      else {
        return 'File size exceeded the limit';
      }
    }
    else {
      return '';
    }
  }
  // ========= Byte to size =====================
  public bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = (Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
  }
  // ========= Delete the file =====================
  public deleteFile(item, i) {
    let uploadArray = this.uploadFiles;
    let payload = { "urlData": [item.guid] }
    // this.commonService.get('delete', 'FileUpload', payload).subscribe((event: any) => {
    uploadArray.splice(i, 1);
    // });
  }
  clickUpload(event) {
    if (event && event.target && event.target.className == 'p-fileupload-content') {
      this.fileUpload();
    }
  }
  fileUpload() {
    jQuery('.p-fileupload-choose').click();
  }
  clickDocument() {
    this.serviceLayer.openLink('documentCenter','', this.policyDetails?.policyNumber);
  }
  ChangeLossOccur() {
    this.dao.reportClaimData.Address = "";
    this.dao.reportClaimData.City = "";
    this.dao.reportClaimData.State = "";
    this.dao.reportClaimData.Zip = null;
  }
  changeLossType(){
    this.dao.reportClaimData.SubTypeOfLoss = "";
    this.isShowSubType = this.dao.reportClaimData.TempTypeOfLoss == "allother_Ext";
  }
  isSubmitBtnDisabled(){
    if(this.dao.reportClaimData.FirstName != undefined && this.dao.reportClaimData.FirstName != '' && 
    this.dao.reportClaimData.Phone != undefined && this.dao.reportClaimData.Phone != '' && this.dao.reportClaimData.Phone != '___-___-____' &&
    this.dao.reportClaimData.LastName != undefined && this.dao.reportClaimData.LastName != '' &&
    this.dao.reportClaimData.DateOfLoss != undefined &&
    this.dao.reportClaimData.TempTypeOfLoss != undefined && this.dao.reportClaimData.TempTypeOfLoss != '' && 
    ((this.dao.reportClaimData.TempTypeOfLoss == "allother_Ext" && this.dao.reportClaimData.SubTypeOfLoss != undefined && this.dao.reportClaimData.SubTypeOfLoss != '') || (this.dao.reportClaimData.TempTypeOfLoss != "allother_Ext")) &&
    this.dao.reportClaimData.isLossProjectAddress != undefined && this.dao.reportClaimData.isLossProjectAddress != '' &&
      (this.dao.reportClaimData.isLossProjectAddress == 'Yes' || 
        (this.dao.reportClaimData.Address != undefined && this.dao.reportClaimData.Address != '' && this.dao.reportClaimData.City != undefined && this.dao.reportClaimData.City != '' && 
        this.dao.reportClaimData.State != undefined && this.dao.reportClaimData.State != '' && this.dao.reportClaimData.Zip != undefined && this.dao.reportClaimData.Zip != '')
      )&& 
    this.dao.reportClaimData.DescriptionOfLoss != undefined && this.dao.reportClaimData.DescriptionOfLoss != ''
    )
    {
      return false;
    }
    if(this.dao.reportClaimData.Phone != undefined && this.dao.reportClaimData.Phone != '' && this.dao.reportClaimData.Phone == '___-___-____'){
      this.dao.reportClaimData.Phone = '';
    }
    return true;
  }
  public async postUserActivity(Payload,Status,RateOnly,ActionType,component,functionality,urlData){
    let userData :any = {};
    userData.Email = this.dao?.loginUserDetail?.email;
    userData.AgencyCode = this.dao.agencyCode;
    userData.PolicyNumber = this.dao.policyNumber;
    userData.InsuredName = this.dao.insuredName;
    userData.ProgressToPage = "Report a Claim";
    let payloadDetail:any={};
    payloadDetail.endPointURL = await this.serviceLayer.getEndPoint(component, functionality, urlData);
    payloadDetail.payload = "";
    payloadDetail.response = Payload;
    userData.Payload = JSON.stringify(payloadDetail);
    userData.TransactionStatus = Status;
    userData.RateOnly = RateOnly;
    userData.ActionType = ActionType;
    this.serviceLayer.postUserActivity(userData);
  }
  async searchForPolicy() {
    
    if(this.PolicyorName != undefined && this.PolicyorName != null && this.PolicyorName.length >0){
      var policyQuotesList : any =[];
      policyQuotesList = await this.serviceLayer.getPoliciesBasedOnSearch(this.dao.loginUserDetail.email,this.PolicyorName);
      
      if(policyQuotesList != undefined && policyQuotesList != null && policyQuotesList.length>0) {
        var policyList = policyQuotesList.filter(s => s.typeName == 'Policy');
      }
      var WantToList = [
        { "label": "Report a claim", "value": "Report a claim", "disabled": false },
        { "label": "Manage a policy", "value": "Manage my policy", "disabled": false },
        { "label": "Request Evidence of insurance", "value": "Request Evidence of insurance", "disabled": false },
        { "label": "Cancel a policy", "value": "Cancel my policy", "disabled": false }
      ];
      if (policyList != undefined && policyList.length > 0) {
        policyList.forEach(policy => {
          policy['wantedTo'] = _.cloneDeep(WantToList);
          if (['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION', 'EXPIRED'].includes(policy.status.toUpperCase())) {
            policy['wantedTo'][3].disabled = true;
          }
        });
      }
      this.PolicyQuotesList = policyQuotesList; 
      this.tempPolicyList = policyQuotesList;
      window.localStorage.setItem("policyQuotesList", JSON.stringify(policyQuotesList));
      this.filterPolicy();
    }
  }
}
